import { Checkbox, DatePicker } from "antd";
import { ErrorMessage, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import * as Action from "../../_redux/applicantActions";

const _init = {
  no_of_q1: "",
  no_of_q2: "",
  no_of_q3: null,
  no_of_q4: null,
  national_publication: null,
  international_publication: "",
  google_scholar_link: "",
  research_details: "",
  documents: null,
};

const PublicationSummery = () => {
  const { id } = useParams();
  const [trainingData, setTrainingData] = useState(_init);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const DOC_CONTAINER = process.env.REACT_APP_IMAGE_BASE_URL;
  const DOC_TOKEN = process.env.REACT_APP_IMAGE_TOKEN_KEY;

  const {
    trainingList,
    personalInfo,
    countryList,
    publicationCommonData,
  } = useSelector(
    ({ applicant }) => ({
      trainingList: applicant.trainingList,
      countryList: applicant.countryList,
      personalInfo: applicant.personal_info,
      publicationCommonData: applicant.publicationCommonData,
    }),
    shallowEqual
  );

  // useEffect(() => {
  //   dispatch(Action.getAllCountry());
  // }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(Action.getPublicationCommonData(id));
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    setTrainingData({
      no_of_q1: publicationCommonData?.no_of_q1,
      no_of_q2: publicationCommonData?.no_of_q2,
      no_of_q3: publicationCommonData?.no_of_q3,
      no_of_q4: publicationCommonData?.no_of_q4,
      national_publication: publicationCommonData?.national_publication,
      international_publication:
        publicationCommonData?.international_publication,
      google_scholar_link: publicationCommonData?.google_scholar_link,
      research_details: publicationCommonData?.research_details,
      // "documents": publicationCommonData?.documents,
    });
  }, [publicationCommonData]);

  // useEffect(() => {
  //   if (trainingList && trainingList.length > 0) {
  //     const data = trainingList?.map((item) => {
  //       return {
  //         training_title: item.hrms_training__training_title,
  //         institution_name: item.hrms_training__institution_name,
  //         country_id: item.hrms_training__country_id,
  //         duration: item.hrms_training__duration,
  //         start_date: item.hrms_training__start_date
  //           ? moment(item.hrms_training__start_date)
  //           : null,
  //         end_date: item.hrms_training__end_date
  //           ? moment(item.hrms_training__end_date)
  //           : null,
  //       };
  //     });
  //     setTrainingData({ list: data });
  //   } else {
  //     // setTrainingData({ list: [_init] });
  //     setTrainingData({ list: [] });
  //   }
  // }, [trainingList]);

  // Validation schema

  const validationSchema = Yup.object().shape({
    no_of_q1: Yup.number()
      .nullable()
      .required("No. of Q1 Journal is required"),
    no_of_q2: Yup.number()
      .nullable()
      .required("No. of Q2 Journal is required"),
    no_of_q3: Yup.number()
      .nullable()
      .required("No. of Q3 Journal is required"),
    no_of_q4: Yup.number()
      .nullable()
      .required("No. of Q4 Journal is required"),
    national_publication: Yup.string().required(
      "No. of National Publication is Required"
    ),
    international_publication: Yup.string().required(
      "No. of International Publication is Required"
    ),
    google_scholar_link: Yup.string().required(
      " Google Scholar Link must be required"
    ),
    // research_details: Yup.string().required('Research Detail must be required'),
    research_details: Yup.string().nullable(),
  });

  const handleSubmitJournal = async (values) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("applicant_id", id);
    formdata.append("no_of_q1", values?.no_of_q1);
    formdata.append("no_of_q2", values?.no_of_q2);
    formdata.append("no_of_q3", values?.no_of_q3);
    formdata.append("no_of_q4", values?.no_of_q4);
    formdata.append("national_publication", values?.national_publication);
    formdata.append(
      "international_publication",
      values?.international_publication
    );
    formdata.append("google_scholar_link", values?.google_scholar_link);
    formdata.append("research_details", values?.research_details);

    if (values?.documents) {
      formdata.append("documents", values?.documents);
    }

    if (publicationCommonData?.id) {
      await API.patch(
        `/hrms-applicant-portal/hrms_publication_common/${publicationCommonData?.id}`,
        formdata
      ).then(async (res) => {
        if (res.data.success) {
          swalSuccess("Journal Update successfully!");
          dispatch(Action.getPublicationCommonData(id));
          setLoading(false);
        }
      });
    } else {
      await API.post(
        "/hrms-applicant-portal/hrms_publication_common",
        formdata
      ).then(async (res) => {
        if (res.data.success) {
          swalSuccess("Journal submitted successfully!");
          dispatch(Action.getPublicationCommonData(id));
          // dispatch(
          //   Action.updateProfileScore(
          //     {
          //       name: ["Publication"],
          //       applicant_id: id,
          //     },
          //     async () => {
          //       dispatch(Action.getApplicantPersonalInfo(id));
          //       await dispatch(Action.getAllEducationByApplicants(id));
          //     }
          //   )
          // );
          dispatch(
            Action.createProfileScore(
              {
                name: ["Publication Summary"],
                applicant_id: id,
              },
              () => {
                dispatch(Action.getApplicantPersonalInfo(id));
              }
            )
          );
          // setTimeout(() => {
          //   dispatch(Action.getApplicantsInfoById(id));
          // }, "300");
          setLoading(false);
        } else {
          swalError("something went wrong");
        }
      });
    }
    setLoading(false);
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={trainingData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmitJournal(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Overall Research Publication Summary</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of international publication"}
                          isRequired
                          value={values.international_publication}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(
                              `international_publication`,
                              e.target.value
                            );
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`international_publication`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of national publication"}
                          isRequired
                          value={values.national_publication}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(
                              `national_publication`,
                              e.target.value
                            );
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`national_publication`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of Q1 Journal"}
                          isRequired
                          value={values.no_of_q1}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(`no_of_q1`, e.target.value);
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`no_of_q1`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of Q2 Journal"}
                          isRequired
                          value={values.no_of_q2}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(`no_of_q2`, e.target.value);
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`no_of_q2`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of Q3 Journal"}
                          isRequired
                          value={values.no_of_q3}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(`no_of_q3`, e.target.value);
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`no_of_q3`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"No. of Q4 Journal"}
                          isRequired
                          value={values.no_of_q4}
                          type="number"
                          onChange={(e) => {
                            setFieldValue(`no_of_q4`, e.target.value);
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`no_of_q4`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"Google scholar link"}
                          isRequired
                          value={values.google_scholar_link}
                          onChange={(e) => {
                            setFieldValue(
                              `google_scholar_link`,
                              e.target.value
                            );
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`google_scholar_link`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <Input
                          label={"Text Box (Research Detail)"}
                          value={values.research_details}
                          onChange={(e) => {
                            setFieldValue(`research_details`, e.target.value);
                          }}
                        />
                        <div className="text-danger">
                          <ErrorMessage name={`research_details`} />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="">
                          Document Upload as per the sample format
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(event) => {
                            setFieldValue("documents", event.target.files[0]);
                          }}
                        />
                        {!values?.documents &&
                          publicationCommonData?.documents && (
                            <a
                              href={
                                DOC_CONTAINER +
                                publicationCommonData?.documents +
                                DOC_TOKEN
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {publicationCommonData?.documents}
                            </a>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!personalInfo?.no_training && (
              <div className="edit_btn_group d-flex modal-footer m-0 p-0">
                {/* <button className='btn btn-default mr-4' >Cancel</button> */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PublicationSummery;
